import styled, { css } from 'styled-components';
import LXStyledButton from './core';

const LXLowButton = styled(LXStyledButton)`
  height: var(--bt-lg-height);
  padding: var(--bt-lg-padding);
  background-color: var(--bt-low-primary-bg);
  &:hover {
    background-color: var(--bt-low-primary-hover);
  }
  ${(props) =>
    props.kind === 'secondary' &&
    css`
      color: var(--bt-low-secondary);
      background-color: var(--bt-low-secondary-bg);
      border: var(--bt-low-border);
      &:hover {
        background-color: var(--bt-low-secondary-hover);
      }
    `}
`;

export default LXLowButton;
